import { useContext } from 'react';
import ExternalAuthContext from './ExternalAuthContext';

const useExternalAuth = () => {
  const context = useContext(ExternalAuthContext);
  
  if (!context) {
    throw new Error('useExternalAuth must be used within an ExternalAuthContextProvider');
  }
  
  return context;
};

export default useExternalAuth;